// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.membersProfile_pageWrp__L6nA2 .membersProfile_profileHeader__YO\\+Au {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid var(--border);
  margin-bottom: 16px;
}
.membersProfile_pageWrp__L6nA2 .membersProfile_profileHeader__YO\\+Au h1 {
  font: var(--h3);
  font-weight: 700;
  color: var(--primary-Text);
  font-family: var(--font-bodoni-72);
}
.membersProfile_pageWrp__L6nA2 .membersProfile_profileHeader__YO\\+Au .membersProfile_right__wrLyV {
  display: flex;
  align-items: center;
  gap: 20px;
}
.membersProfile_pageWrp__L6nA2 .membersProfile_profileHeader__YO\\+Au .membersProfile_right__wrLyV .membersProfile_date__xdyHr {
  display: flex;
  align-items: center;
  gap: 4px;
}
.membersProfile_pageWrp__L6nA2 .membersProfile_profileHeader__YO\\+Au .membersProfile_right__wrLyV .membersProfile_date__xdyHr img,
.membersProfile_pageWrp__L6nA2 .membersProfile_profileHeader__YO\\+Au .membersProfile_right__wrLyV .membersProfile_date__xdyHr svg {
  width: 16px;
  height: 16px;
  object-fit: scale-down;
  display: block;
}
.membersProfile_pageWrp__L6nA2 .membersProfile_profileHeader__YO\\+Au .membersProfile_right__wrLyV .membersProfile_date__xdyHr span {
  font: var(--body-font-four);
  color: var(--primary-Text);
  display: block;
}
.membersProfile_pageWrp__L6nA2 .membersProfile_profileRow__4TnmJ {
  padding: 6px 24px 24px 24px;
}
.membersProfile_pageWrp__L6nA2 .membersProfile_profileRow__4TnmJ .membersProfile_profileLeft__kVt2u {
  display: flex;
  align-items: center;
  gap: 16px;
}
.membersProfile_pageWrp__L6nA2 .membersProfile_profileRow__4TnmJ .membersProfile_profileLeft__kVt2u .membersProfile_avatar__GKYcV {
  width: 96px;
  height: 96px;
  border-radius: 50%;
}
.membersProfile_pageWrp__L6nA2 .membersProfile_profileRow__4TnmJ .membersProfile_profileLeft__kVt2u .membersProfile_profileDetail__DIJWc {
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.membersProfile_pageWrp__L6nA2 .membersProfile_profileRow__4TnmJ .membersProfile_profileLeft__kVt2u .membersProfile_profileDetail__DIJWc h2 {
  font: var(--h5);
  font-weight: 600;
  color: var(--primary-Text);
  text-align: left;
  text-transform: capitalize;
}
.membersProfile_pageWrp__L6nA2 .membersProfile_profileRow__4TnmJ .membersProfile_profileLeft__kVt2u .membersProfile_profileDetail__DIJWc p {
  font: var(--body-font-three);
  color: var(--brand);
  font-weight: 500;
  text-align: left;
}
.membersProfile_pageWrp__L6nA2 .membersProfile_profileRow__4TnmJ .membersProfile_profileLeft__kVt2u .membersProfile_profileDetail__DIJWc .membersProfile_status__9bscY {
  width: max-content;
}
.membersProfile_pageWrp__L6nA2 .membersProfile_profileRow__4TnmJ .membersProfile_profileRight__embww .membersProfile_profileBtns__ZJ6f2 {
  display: flex;
  gap: 10px;
  flex: 1 1;
  justify-content: flex-end;
}
.membersProfile_pageWrp__L6nA2 .membersProfile_profileRow__4TnmJ .membersProfile_profileRight__embww .membersProfile_profileBtns__ZJ6f2 .membersProfile_dropdownBtn__Q\\+RI\\+ {
  padding: 2px;
}
.membersProfile_pageWrp__L6nA2 .membersProfile_profileTab__XFeek {
  padding: 0 24px;
}
.membersProfile_pageWrp__L6nA2 .membersProfile_profileTab__XFeek .membersProfile_membersProfileTabs__BklxF .membersProfile_tabItem__LOGAv {
  display: flex;
  align-items: center;
  gap: 8px;
  text-align: left;
}
.membersProfile_pageWrp__L6nA2 .membersProfile_profileTab__XFeek .membersProfile_membersProfileTabs__BklxF .membersProfile_tabItem__LOGAv img,
.membersProfile_pageWrp__L6nA2 .membersProfile_profileTab__XFeek .membersProfile_membersProfileTabs__BklxF .membersProfile_tabItem__LOGAv svg {
  width: 16px;
  height: 16px;
  display: block;
}
.membersProfile_pageWrp__L6nA2 .membersProfile_profileTab__XFeek .membersProfile_membersProfileTabs__BklxF .membersProfile_tabContentWrp__OeF7a {
  margin-top: 24px;
}
.membersProfile_pageWrp__L6nA2 .membersProfile_profileTab__XFeek .membersProfile_membersProfileTabs__BklxF .membersProfile_profileDetailsWrp__gFmPH {
  padding: 16px;
  border-radius: var(--border-radius-large);
  border: 1px solid var(--border);
}
.membersProfile_pageWrp__L6nA2 .membersProfile_profileTab__XFeek .membersProfile_membersProfileTabs__BklxF .membersProfile_profileDetailsWrp__gFmPH .membersProfile_titleRow__xPjJ5 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}
.membersProfile_pageWrp__L6nA2 .membersProfile_profileTab__XFeek .membersProfile_membersProfileTabs__BklxF .membersProfile_profileDetailsWrp__gFmPH .membersProfile_titleRow__xPjJ5 h3 {
  font: var(--body-font-two);
  font-weight: 600;
  color: var(--primary-Text);
}
.membersProfile_pageWrp__L6nA2 .membersProfile_profileTab__XFeek .membersProfile_membersProfileTabs__BklxF .membersProfile_profileDetailsWrp__gFmPH .membersProfile_titleRow__xPjJ5 .membersProfile_editIcon__hEpSX {
  width: 16px;
  height: 16px;
  display: block;
  cursor: pointer;
}
.membersProfile_pageWrp__L6nA2 .membersProfile_profileTab__XFeek .membersProfile_membersProfileTabs__BklxF .membersProfile_profileDetailsWrp__gFmPH .membersProfile_detailInfo__Cfxnb {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}
.membersProfile_pageWrp__L6nA2 .membersProfile_profileTab__XFeek .membersProfile_membersProfileTabs__BklxF .membersProfile_profileDetailsWrp__gFmPH .membersProfile_detailInfo__Cfxnb .membersProfile_infoItem__0kSO2 label {
  font: var(--body-font-four);
  color: var(--brand);
  display: block;
  margin-bottom: 4px;
}
.membersProfile_pageWrp__L6nA2 .membersProfile_profileTab__XFeek .membersProfile_membersProfileTabs__BklxF .membersProfile_profileDetailsWrp__gFmPH .membersProfile_detailInfo__Cfxnb .membersProfile_infoItem__0kSO2 input {
  font: var(--body-font-three);
  color: var(--primary-Text);
  font-weight: 500;
  border: unset;
  padding: 0;
  outline: unset;
  margin: 0;
}
.membersProfile_pageWrp__L6nA2 .membersProfile_profileTab__XFeek .membersProfile_membersProfileTabs__BklxF .membersProfile_profileDetailsWrp__gFmPH .membersProfile_detailInfo__Cfxnb .membersProfile_infoItem__0kSO2 input[type=number]::-webkit-inner-spin-button,
.membersProfile_pageWrp__L6nA2 .membersProfile_profileTab__XFeek .membersProfile_membersProfileTabs__BklxF .membersProfile_profileDetailsWrp__gFmPH .membersProfile_detailInfo__Cfxnb .membersProfile_infoItem__0kSO2 input[type=number]::-webkit-outer-spin-button {
  appearance: none;
}
.membersProfile_pageWrp__L6nA2 .membersProfile_profileTab__XFeek .membersProfile_membersProfileTabs__BklxF .membersProfile_profileDetailsWrp__gFmPH .membersProfile_detailInfo__Cfxnb .membersProfile_infoItem__0kSO2.membersProfile_formGroup__UL11x {
  margin-bottom: 12px;
  position: relative;
  width: 20em;
  height: 45px;
}
.membersProfile_pageWrp__L6nA2 .membersProfile_profileTab__XFeek .membersProfile_membersProfileTabs__BklxF .membersProfile_profileDetailsWrp__gFmPH .membersProfile_detailInfo__Cfxnb .membersProfile_infoItem__0kSO2.membersProfile_formGroup__UL11x input {
  padding: 10px 12px;
}
.membersProfile_pageWrp__L6nA2 .membersProfile_profileTab__XFeek .membersProfile_membersProfileTabs__BklxF .membersProfile_taskTimelineWrp__WcFs3 .membersProfile_timeLineTopRow__TT4G- {
  width: 100%;
  padding-bottom: 12px;
}
.membersProfile_pageWrp__L6nA2 .membersProfile_profileTab__XFeek .membersProfile_membersProfileTabs__BklxF .membersProfile_taskTimelineWrp__WcFs3 .membersProfile_timeLineTopRow__TT4G- .membersProfile_filterBtns__B75mp {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  flex: 1 1;
  justify-content: flex-end;
}
.membersProfile_pageWrp__L6nA2 .membersProfile_profileTab__XFeek .membersProfile_membersProfileTabs__BklxF .membersProfile_taskTimelineWrp__WcFs3 .membersProfile_timeLineTopRow__TT4G- .membersProfile_filterBtns__B75mp .membersProfile_rightActions__YPd\\+\\+ {
  display: flex;
  align-items: center;
  gap: 12px;
}

@media (max-width: 991px) {
  .membersProfile_pageWrp__L6nA2 .membersProfile_profileRow__4TnmJ .membersProfile_profileLeft__kVt2u {
    gap: 10px;
  }
  .membersProfile_pageWrp__L6nA2 .membersProfile_profileRow__4TnmJ .membersProfile_profileLeft__kVt2u .membersProfile_avatar__GKYcV {
    width: 78px;
    height: 78px;
  }
  .membersProfile_pageWrp__L6nA2 .membersProfile_profileRow__4TnmJ .membersProfile_profileLeft__kVt2u .membersProfile_profileDetail__DIJWc {
    gap: 5px;
  }
  .membersProfile_pageWrp__L6nA2 .membersProfile_profileRow__4TnmJ .membersProfile_profileLeft__kVt2u .membersProfile_profileDetail__DIJWc h2 {
    font: var(--h6);
  }
  .membersProfile_pageWrp__L6nA2 .membersProfile_profileRow__4TnmJ .membersProfile_profileLeft__kVt2u .membersProfile_profileDetail__DIJWc p {
    font: var(--body-font-four);
  }
  .membersProfile_pageWrp__L6nA2 .membersProfile_profileRow__4TnmJ .membersProfile_profileRight__embww .membersProfile_profileBtns__ZJ6f2 {
    gap: 8px;
  }
  .membersProfile_pageWrp__L6nA2 .membersProfile_profileRow__4TnmJ .membersProfile_profileRight__embww .membersProfile_profileBtns__ZJ6f2 button,
  .membersProfile_pageWrp__L6nA2 .membersProfile_profileRow__4TnmJ .membersProfile_profileRight__embww .membersProfile_profileBtns__ZJ6f2 a {
    min-height: 35px;
    padding: 6px 10px;
    font-size: 12px;
    gap: 5px;
  }
  .membersProfile_pageWrp__L6nA2 .membersProfile_profileRow__4TnmJ .membersProfile_profileRight__embww .membersProfile_profileBtns__ZJ6f2 .membersProfile_dropdownBtn__Q\\+RI\\+ {
    padding: 0;
  }
  .membersProfile_pageWrp__L6nA2 .membersProfile_profileRow__4TnmJ .membersProfile_profileRight__embww .membersProfile_profileBtns__ZJ6f2 .membersProfile_dropdownBtn__Q\\+RI\\+ button {
    width: 35px;
    height: 35px;
  }
}
@media (max-width: 767px) {
  .membersProfile_pageWrp__L6nA2 .membersProfile_profileHeader__YO\\+Au {
    padding: 16px;
  }
  .membersProfile_pageWrp__L6nA2 .membersProfile_profileRow__4TnmJ {
    padding: 6px 16px 16px 16px;
  }
  .membersProfile_pageWrp__L6nA2 .membersProfile_profileTab__XFeek {
    padding: 0 16px;
  }
}
@media (max-width: 599px) {
  .membersProfile_pageWrp__L6nA2 .membersProfile_profileRow__4TnmJ .membersProfile_profileRight__embww .membersProfile_profileBtns__ZJ6f2 {
    justify-content: left;
  }
  .membersProfile_pageWrp__L6nA2 .membersProfile_profileTab__XFeek .membersProfile_membersProfileTabs__BklxF .membersProfile_tabContentWrp__OeF7a {
    margin-top: 15px;
  }
  .membersProfile_pageWrp__L6nA2 .membersProfile_profileTab__XFeek .membersProfile_membersProfileTabs__BklxF .membersProfile_profileDetailsWrp__gFmPH {
    padding: 10px;
  }
  .membersProfile_pageWrp__L6nA2 .membersProfile_profileTab__XFeek .membersProfile_membersProfileTabs__BklxF .membersProfile_profileDetailsWrp__gFmPH .membersProfile_titleRow__xPjJ5 {
    margin-bottom: 10px;
  }
  .membersProfile_pageWrp__L6nA2 .membersProfile_profileTab__XFeek .membersProfile_membersProfileTabs__BklxF .membersProfile_profileDetailsWrp__gFmPH .membersProfile_detailInfo__Cfxnb {
    grid-template-columns: repeat(1, 1fr);
    gap: 10px;
  }
  .membersProfile_pageWrp__L6nA2 .membersProfile_profileTab__XFeek .membersProfile_membersProfileTabs__BklxF .membersProfile_taskTimelineWrp__WcFs3 .membersProfile_timeLineTopRow__TT4G- .membersProfile_filterBtns__B75mp {
    flex-direction: column;
    align-items: flex-start;
  }
  .membersProfile_pageWrp__L6nA2 .membersProfile_profileTab__XFeek .membersProfile_membersProfileTabs__BklxF .membersProfile_taskTimelineWrp__WcFs3 .membersProfile_timeLineTopRow__TT4G- .membersProfile_filterBtns__B75mp .membersProfile_rightActions__YPd\\+\\+ {
    width: 100%;
  }
  .membersProfile_pageWrp__L6nA2 .membersProfile_profileTab__XFeek .membersProfile_membersProfileTabs__BklxF .membersProfile_taskTimelineWrp__WcFs3 .membersProfile_timeLineTopRow__TT4G- .membersProfile_filterBtns__B75mp .membersProfile_rightActions__YPd\\+\\+ button {
    width: 100%;
  }
}
.membersProfile_searchRow__z5\\+\\+0 {
  margin-bottom: 16px;
}
.membersProfile_searchRow__z5\\+\\+0 .membersProfile_right__wrLyV {
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 10px;
}

.membersProfile_addEntryModal__J9QLs .membersProfile_footerBtns__pmuab {
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 16px;
}

.membersProfile_formWrp__EtIKx {
  max-height: 550px;
  overflow-y: auto;
}
.membersProfile_formWrp__EtIKx .membersProfile_formField__xfRtM {
  margin-bottom: 16px;
}
.membersProfile_formWrp__EtIKx .membersProfile_formField__xfRtM .membersProfile_label__Z0r6M {
  font: var(--body-font-three);
  color: var(--secondary-Text);
  display: block;
  margin-bottom: 4px;
}`, "",{"version":3,"sources":["webpack://./src/pages/profile/membersProfile.module.scss"],"names":[],"mappings":"AACC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,sCAAA;EACA,mBAAA;AAAF;AAEE;EACC,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kCAAA;AAAH;AAGE;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AADH;AAGG;EACC,aAAA;EACA,mBAAA;EACA,QAAA;AADJ;AAGI;;EAEC,WAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;AADL;AAII;EACC,2BAAA;EACA,0BAAA;EACA,cAAA;AAFL;AAWC;EACC,2BAAA;AATF;AAWE;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AATH;AAWG;EACC,WAAA;EACA,YAAA;EACA,kBAAA;AATJ;AAYG;EACC,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAVJ;AAYI;EACC,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,gBAAA;EACA,0BAAA;AAVL;AAaI;EACC,4BAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AAXL;AAcI;EACC,kBAAA;AAZL;AAkBG;EACC,aAAA;EACA,SAAA;EACA,SAAA;EACA,yBAAA;AAhBJ;AAkBI;EACC,YAAA;AAhBL;AAsBC;EACC,eAAA;AApBF;AAuBG;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AArBJ;AAuBI;;EAEC,WAAA;EACA,YAAA;EACA,cAAA;AArBL;AAyBG;EACC,gBAAA;AAvBJ;AA0BG;EACC,aAAA;EACA,yCAAA;EACA,+BAAA;AAxBJ;AA0BI;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAxBL;AA0BK;EACC,0BAAA;EACA,gBAAA;EACA,0BAAA;AAxBN;AA2BK;EACC,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AAzBN;AA6BI;EACC,aAAA;EACA,qCAAA;EACA,SAAA;AA3BL;AA8BM;EACC,2BAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AA5BP;AA+BM;EACC,4BAAA;EACA,0BAAA;EACA,gBAAA;EACA,aAAA;EACA,UAAA;EACA,cAAA;EACA,SAAA;AA7BP;AA+BM;;EAIC,gBAAA;AA7BP;AA+BM;EACC,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AA7BP;AA8BO;EACC,kBAAA;AA5BR;AAoCI;EACC,WAAA;EACA,oBAAA;AAlCL;AAuCK;EACC,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;AArCN;AA0CM;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AAxCP;;AAiDA;EAGG;IACC,SAAA;EAhDF;EAkDE;IACC,WAAA;IACA,YAAA;EAhDH;EAmDE;IACC,QAAA;EAjDH;EAmDG;IACC,eAAA;EAjDJ;EAoDG;IACC,2BAAA;EAlDJ;EAwDE;IACC,QAAA;EAtDH;EAwDG;;IAEC,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,QAAA;EAtDJ;EAyDG;IACC,UAAA;EAvDJ;EAyDI;IACC,WAAA;IACA,YAAA;EAvDL;AACF;AA+DA;EAEE;IACC,aAAA;EA9DD;EAiEA;IACC,2BAAA;EA/DD;EAkEA;IACC,eAAA;EAhED;AACF;AAoEA;EAII;IACC,qBAAA;EArEH;EA4EE;IACC,gBAAA;EA1EH;EA6EE;IACC,aAAA;EA3EH;EA6EG;IACC,mBAAA;EA3EJ;EA8EG;IACC,qCAAA;IACA,SAAA;EA5EJ;EAkFI;IACC,sBAAA;IAEA,uBAAA;EAjFL;EAmFK;IACC,WAAA;EAjFN;EAmFM;IACC,WAAA;EAjFP;AACF;AA2FA;EACC,mBAAA;AAzFD;AA2FC;EACC,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;AAzFF;;AA8FC;EACC,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;AA3FF;;AA+FA;EACC,iBAAA;EACA,gBAAA;AA5FD;AA8FC;EACC,mBAAA;AA5FF;AA8FE;EACC,4BAAA;EACA,4BAAA;EACA,cAAA;EACA,kBAAA;AA5FH","sourcesContent":[".pageWrp {\r\n\t.profileHeader {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: center;\r\n\t\tpadding: 16px 24px;\r\n\t\tborder-bottom: 1px solid var(--border);\r\n\t\tmargin-bottom: 16px;\r\n\r\n\t\th1 {\r\n\t\t\tfont: var(--h3);\r\n\t\t\tfont-weight: 700;\r\n\t\t\tcolor: var(--primary-Text);\r\n\t\t\tfont-family: var(--font-bodoni-72);\r\n\t\t}\r\n\r\n\t\t.right {\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 20px;\r\n\r\n\t\t\t.date {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tgap: 4px;\r\n\r\n\t\t\t\timg,\r\n\t\t\t\tsvg {\r\n\t\t\t\t\twidth: 16px;\r\n\t\t\t\t\theight: 16px;\r\n\t\t\t\t\tobject-fit: scale-down;\r\n\t\t\t\t\tdisplay: block;\r\n\t\t\t\t}\r\n\r\n\t\t\t\tspan {\r\n\t\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t\tdisplay: block;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t.inviteBtn {\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.profileRow {\r\n\t\tpadding: 6px 24px 24px 24px;\r\n\r\n\t\t.profileLeft {\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 16px;\r\n\r\n\t\t\t.avatar {\r\n\t\t\t\twidth: 96px;\r\n\t\t\t\theight: 96px;\r\n\t\t\t\tborder-radius: 50%;\r\n\t\t\t}\r\n\r\n\t\t\t.profileDetail {\r\n\t\t\t\ttext-align: left;\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tflex-direction: column;\r\n\t\t\t\tgap: 8px;\r\n\r\n\t\t\t\th2 {\r\n\t\t\t\t\tfont: var(--h5);\r\n\t\t\t\t\tfont-weight: 600;\r\n\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t\ttext-align: left;\r\n\t\t\t\t\ttext-transform: capitalize;\r\n\t\t\t\t}\r\n\r\n\t\t\t\tp {\r\n\t\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\t\tcolor: var(--brand);\r\n\t\t\t\t\tfont-weight: 500;\r\n\t\t\t\t\ttext-align: left;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t.status {\r\n\t\t\t\t\twidth: max-content;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.profileRight {\r\n\t\t\t.profileBtns {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tgap: 10px;\r\n\t\t\t\tflex: 1;\r\n\t\t\t\tjustify-content: flex-end;\r\n\r\n\t\t\t\t.dropdownBtn {\r\n\t\t\t\t\tpadding: 2px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.profileTab {\r\n\t\tpadding: 0 24px;\r\n\r\n\t\t.membersProfileTabs {\r\n\t\t\t.tabItem {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tgap: 8px;\r\n\t\t\t\ttext-align: left;\r\n\r\n\t\t\t\timg,\r\n\t\t\t\tsvg {\r\n\t\t\t\t\twidth: 16px;\r\n\t\t\t\t\theight: 16px;\r\n\t\t\t\t\tdisplay: block;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t.tabContentWrp {\r\n\t\t\t\tmargin-top: 24px;\r\n\t\t\t}\r\n\r\n\t\t\t.profileDetailsWrp {\r\n\t\t\t\tpadding: 16px;\r\n\t\t\t\tborder-radius: var(--border-radius-large);\r\n\t\t\t\tborder: 1px solid var(--border);\r\n\r\n\t\t\t\t.titleRow {\r\n\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\tjustify-content: space-between;\r\n\t\t\t\t\talign-items: center;\r\n\t\t\t\t\tgap: 10px;\r\n\t\t\t\t\tmargin-bottom: 16px;\r\n\r\n\t\t\t\t\th3 {\r\n\t\t\t\t\t\tfont: var(--body-font-two);\r\n\t\t\t\t\t\tfont-weight: 600;\r\n\t\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\t.editIcon {\r\n\t\t\t\t\t\twidth: 16px;\r\n\t\t\t\t\t\theight: 16px;\r\n\t\t\t\t\t\tdisplay: block;\r\n\t\t\t\t\t\tcursor: pointer;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\r\n\t\t\t\t.detailInfo {\r\n\t\t\t\t\tdisplay: grid;\r\n\t\t\t\t\tgrid-template-columns: repeat(2, 1fr);\r\n\t\t\t\t\tgap: 16px;\r\n\r\n\t\t\t\t\t.infoItem {\r\n\t\t\t\t\t\tlabel {\r\n\t\t\t\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\t\t\t\tcolor: var(--brand);\r\n\t\t\t\t\t\t\tdisplay: block;\r\n\t\t\t\t\t\t\tmargin-bottom: 4px;\r\n\t\t\t\t\t\t}\r\n\r\n\t\t\t\t\t\tinput {\r\n\t\t\t\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t\t\t\tfont-weight: 500;\r\n\t\t\t\t\t\t\tborder: unset;\r\n\t\t\t\t\t\t\tpadding: 0;\r\n\t\t\t\t\t\t\toutline: unset;\r\n\t\t\t\t\t\t\tmargin: 0;\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t\tinput[type=\"number\"]::-webkit-inner-spin-button,\r\n\t\t\t\t\t\tinput[type=\"number\"]::-webkit-outer-spin-button {\r\n\t\t\t\t\t\t\t-webkit-appearance: none;\r\n\t\t\t\t\t\t\t-moz-appearance: none;\r\n\t\t\t\t\t\t\tappearance: none;\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t\t&.formGroup {\r\n\t\t\t\t\t\t\tmargin-bottom: 12px;\r\n\t\t\t\t\t\t\tposition: relative;\r\n\t\t\t\t\t\t\twidth: 20em;\r\n\t\t\t\t\t\t\theight: 45px;\r\n\t\t\t\t\t\t\tinput {\r\n\t\t\t\t\t\t\t\tpadding: 10px 12px;\r\n\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t.taskTimelineWrp {\r\n\t\t\t\t.timeLineTopRow {\r\n\t\t\t\t\twidth: 100%;\r\n\t\t\t\t\tpadding-bottom: 12px;\r\n\r\n\t\t\t\t\t.searchContainer {\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\t.filterBtns {\r\n\t\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\t\tflex-wrap: wrap;\r\n\t\t\t\t\t\tgap: 12px;\r\n\t\t\t\t\t\talign-items: center;\r\n\t\t\t\t\t\tflex: 1;\r\n\t\t\t\t\t\tjustify-content: flex-end;\r\n\r\n\t\t\t\t\t\t.left {\r\n\t\t\t\t\t\t}\r\n\r\n\t\t\t\t\t\t.rightActions {\r\n\t\t\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\t\t\talign-items: center;\r\n\t\t\t\t\t\t\tgap: 12px;\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 991px) {\r\n\t.pageWrp {\r\n\t\t.profileRow {\r\n\t\t\t.profileLeft {\r\n\t\t\t\tgap: 10px;\r\n\r\n\t\t\t\t.avatar {\r\n\t\t\t\t\twidth: 78px;\r\n\t\t\t\t\theight: 78px;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t.profileDetail {\r\n\t\t\t\t\tgap: 5px;\r\n\r\n\t\t\t\t\th2 {\r\n\t\t\t\t\t\tfont: var(--h6);\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\tp {\r\n\t\t\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t.profileRight {\r\n\t\t\t\t.profileBtns {\r\n\t\t\t\t\tgap: 8px;\r\n\r\n\t\t\t\t\tbutton,\r\n\t\t\t\t\ta {\r\n\t\t\t\t\t\tmin-height: 35px;\r\n\t\t\t\t\t\tpadding: 6px 10px;\r\n\t\t\t\t\t\tfont-size: 12px;\r\n\t\t\t\t\t\tgap: 5px;\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\t.dropdownBtn {\r\n\t\t\t\t\t\tpadding: 0;\r\n\r\n\t\t\t\t\t\tbutton {\r\n\t\t\t\t\t\t\twidth: 35px;\r\n\t\t\t\t\t\t\theight: 35px;\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 767px) {\r\n\t.pageWrp {\r\n\t\t.profileHeader {\r\n\t\t\tpadding: 16px;\r\n\t\t}\r\n\r\n\t\t.profileRow {\r\n\t\t\tpadding: 6px 16px 16px 16px;\r\n\t\t}\r\n\r\n\t\t.profileTab {\r\n\t\t\tpadding: 0 16px;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 599px) {\r\n\t.pageWrp {\r\n\t\t.profileRow {\r\n\t\t\t.profileRight {\r\n\t\t\t\t.profileBtns {\r\n\t\t\t\t\tjustify-content: left;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.profileTab {\r\n\t\t\t.membersProfileTabs {\r\n\t\t\t\t.tabContentWrp {\r\n\t\t\t\t\tmargin-top: 15px;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t.profileDetailsWrp {\r\n\t\t\t\t\tpadding: 10px;\r\n\r\n\t\t\t\t\t.titleRow {\r\n\t\t\t\t\t\tmargin-bottom: 10px;\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\t.detailInfo {\r\n\t\t\t\t\t\tgrid-template-columns: repeat(1, 1fr);\r\n\t\t\t\t\t\tgap: 10px;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\r\n\t\t\t\t.taskTimelineWrp {\r\n\t\t\t\t\t.timeLineTopRow {\r\n\t\t\t\t\t\t.filterBtns {\r\n\t\t\t\t\t\t\tflex-direction: column;\r\n\r\n\t\t\t\t\t\t\talign-items: flex-start;\r\n\r\n\t\t\t\t\t\t\t.rightActions {\r\n\t\t\t\t\t\t\t\twidth: 100%;\r\n\r\n\t\t\t\t\t\t\t\tbutton {\r\n\t\t\t\t\t\t\t\t\twidth: 100%;\r\n\t\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n// Time off styles\r\n.searchRow {\r\n\tmargin-bottom: 16px;\r\n\r\n\t.right {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: end;\r\n\t\talign-items: center;\r\n\t\tgap: 10px;\r\n\t}\r\n}\r\n\r\n.addEntryModal {\r\n\t.footerBtns {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: end;\r\n\t\talign-items: center;\r\n\t\tgap: 16px;\r\n\t}\r\n}\r\n\r\n.formWrp {\r\n\tmax-height: 550px;\r\n\toverflow-y: auto;\r\n\r\n\t.formField {\r\n\t\tmargin-bottom: 16px;\r\n\r\n\t\t.label {\r\n\t\t\tfont: var(--body-font-three);\r\n\t\t\tcolor: var(--secondary-Text);\r\n\t\t\tdisplay: block;\r\n\t\t\tmargin-bottom: 4px;\r\n\t\t}\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrp": `membersProfile_pageWrp__L6nA2`,
	"profileHeader": `membersProfile_profileHeader__YO+Au`,
	"right": `membersProfile_right__wrLyV`,
	"date": `membersProfile_date__xdyHr`,
	"profileRow": `membersProfile_profileRow__4TnmJ`,
	"profileLeft": `membersProfile_profileLeft__kVt2u`,
	"avatar": `membersProfile_avatar__GKYcV`,
	"profileDetail": `membersProfile_profileDetail__DIJWc`,
	"status": `membersProfile_status__9bscY`,
	"profileRight": `membersProfile_profileRight__embww`,
	"profileBtns": `membersProfile_profileBtns__ZJ6f2`,
	"dropdownBtn": `membersProfile_dropdownBtn__Q+RI+`,
	"profileTab": `membersProfile_profileTab__XFeek`,
	"membersProfileTabs": `membersProfile_membersProfileTabs__BklxF`,
	"tabItem": `membersProfile_tabItem__LOGAv`,
	"tabContentWrp": `membersProfile_tabContentWrp__OeF7a`,
	"profileDetailsWrp": `membersProfile_profileDetailsWrp__gFmPH`,
	"titleRow": `membersProfile_titleRow__xPjJ5`,
	"editIcon": `membersProfile_editIcon__hEpSX`,
	"detailInfo": `membersProfile_detailInfo__Cfxnb`,
	"infoItem": `membersProfile_infoItem__0kSO2`,
	"formGroup": `membersProfile_formGroup__UL11x`,
	"taskTimelineWrp": `membersProfile_taskTimelineWrp__WcFs3`,
	"timeLineTopRow": `membersProfile_timeLineTopRow__TT4G-`,
	"filterBtns": `membersProfile_filterBtns__B75mp`,
	"rightActions": `membersProfile_rightActions__YPd++`,
	"searchRow": `membersProfile_searchRow__z5++0`,
	"addEntryModal": `membersProfile_addEntryModal__J9QLs`,
	"footerBtns": `membersProfile_footerBtns__pmuab`,
	"formWrp": `membersProfile_formWrp__EtIKx`,
	"formField": `membersProfile_formField__xfRtM`,
	"label": `membersProfile_label__Z0r6M`
};
export default ___CSS_LOADER_EXPORT___;
